var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.1793L15.2441 16.4233L16.4226 15.2448L11.1786 10.0008L16.4226 4.75671L15.2441 3.5782L10.0001 8.82224L4.75596 3.57812L3.57745 4.75664L8.82157 10.0008L3.57745 15.2449L4.75596 16.4234L10.0001 11.1793Z",
    fill: "#606060"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "assets/c0b3cea0.svg";